










import { constToTitle } from "@/utils/conversion";
import { TimeRange } from "@/types/time-range";
import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";

@Component
export default class TimeRangeControls extends Vue {
  @State(state => state.timeRange) currentTimeRange!: TimeRange;

  get timeRanges() {
    return TimeRange;
  }

  isActive(timeRange: TimeRange): boolean {
    return this.currentTimeRange === timeRange;
  }

  setTimeRange(newTimeRange: TimeRange) {
    this.$ga.toggle(newTimeRange);
    this.$store.dispatch("setTimeRange", newTimeRange);
  }

  buttonTitle(value: string): string {
    return constToTitle(value);
  }
}
